import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../utils/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(email, password);
      localStorage.setItem('token', res.token);
      localStorage.setItem('user', JSON.stringify(res.user));
      navigate('/');
    } catch (err) {
      setError(err.message || 'Login failed');
    }
    setLoading(false);
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-background)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-main)' }}>
      <div style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-lg)', padding: '40px 36px', width: '100%', maxWidth: 400, boxShadow: 'var(--shadow-modal)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 32 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--color-teal)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}>PC</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--color-text-dark)', letterSpacing: '-0.3px' }}>Procura</div>
        </div>
        <div style={{ fontSize: 24, fontWeight: 700, color: 'var(--color-text-dark)', marginBottom: 6 }}>Welcome back</div>
        <div style={{ fontSize: 14, color: 'var(--color-text-mid)', marginBottom: 28 }}>Sign in to your procurement platform</div>
        {error && <div style={{ background: '#FEF2F2', border: '1px solid var(--color-error)', color: 'var(--color-error)', padding: '10px 14px', borderRadius: 'var(--radius-md)', fontSize: 13, marginBottom: 16 }}>{error}</div>}
        <form onSubmit={handleLogin}>
          <label style={{ fontSize: 13, fontWeight: 500, color: 'var(--color-text-mid)', display: 'block', marginBottom: 6 }}>Email address</label>
          <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" required style={{ marginBottom: 16 }} />
          <label style={{ fontSize: 13, fontWeight: 500, color: 'var(--color-text-mid)', display: 'block', marginBottom: 6 }}>Password</label>
          <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required style={{ marginBottom: 24 }} />
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '11px', background: loading ? 'var(--color-text-light)' : 'var(--color-teal)', color: '#fff', border: 'none', borderRadius: 'var(--radius-md)', fontSize: 14, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'var(--font-main)' }}>
            {loading ? 'Signing in...' : 'Sign in →'}
          </button>
        </form>
        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 13, color: 'var(--color-text-mid)' }}>
          Don't have an account?{' '}<Link to="/register" style={{ color: 'var(--color-teal)', fontWeight: 600, textDecoration: 'none' }}>Register</Link>
        </div>
      </div>
    </div>
  );
}